import router from './router'
import store from './store/store.js'

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/login' && store.getters.logged) {
    next('/admin');
  }
  if (to.matched.some(record => record.meta.guarded)) {
    if (! store.getters.logged) {
      next('/login');
    }
  }
  if (to.fullPath === '/logout') {
    store.dispatch('login', {});
    next('/login');
  }
  next();
});
